import { render, staticRenderFns } from "./MintI1C1P1.vue?vue&type=template&id=4826fa5f&scoped=true&"
import script from "./MintI1C1P1.vue?vue&type=script&lang=js&"
export * from "./MintI1C1P1.vue?vue&type=script&lang=js&"
import style0 from "./MintI1C1P1.vue?vue&type=style&index=0&id=4826fa5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4826fa5f",
  null
  
)

export default component.exports